import { fetchApi } from '@/config/axiosSetting.ts';
import { UserInfoQueryResponseType } from '@/common/queries/userInfo/userInfoQuery.type.ts';

export const userInfoQueryFunction = (): Promise<UserInfoQueryResponseType> =>
  fetchApi({
    url: 'user_information/user_info/',
  });
